/* AR Page — shared interactivity for light-mode pages. Idempotent. */
(function(){
  if(window.__arpLoaded){return;}
  window.__arpLoaded=true;

  function init(){
    /* Scroll reveal */
    if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      var els=document.querySelectorAll('.arp-reveal:not(.arp-reveal--visible)');
      if(els.length){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting){e.target.classList.add('arp-reveal--visible');io.unobserve(e.target);}
          });
        },{threshold:0.06,rootMargin:'0px 0px -40px 0px'});
        els.forEach(function(el){io.observe(el);});
      }
    }

    /* Affirm As-Low-As refresh */
    if(!window.__arpAffirmTicked){
      window.__arpAffirmTicked=true;
      if(document.querySelector('.affirm-as-low-as[data-amount]')){
        var tries=0,maxTries=40;
        var tick=setInterval(function(){
          tries++;
          if(window.affirm&&window.affirm.ui&&typeof window.affirm.ui.refresh==='function'){
            try{window.affirm.ui.refresh();}catch(e){}
            clearInterval(tick);
          } else if(tries>=maxTries){clearInterval(tick);}
        },250);
      }
    }

    /* Sticky CTA visibility */
    var sticky=document.getElementById('arp-sticky');
    if(sticky&&!sticky.__arpBound){
      sticky.__arpBound=true;
      var dismissed=false;
      try{dismissed=sessionStorage.getItem('arp_sticky_dismissed')==='1';}catch(e){}
      if(!dismissed){
        var sentry=document.createElement('div');
        sentry.style.cssText='position:absolute;top:600px;left:0;width:1px;height:1px;pointer-events:none';
        document.body.appendChild(sentry);
        new IntersectionObserver(function(es){
          es.forEach(function(e){
            if(!e.isIntersecting&&window.scrollY>400){sticky.classList.add('arp-sticky--visible');}
          });
        },{threshold:0}).observe(sentry);
      }
      var dismiss=sticky.querySelector('[data-arp-sticky-dismiss]');
      if(dismiss){
        dismiss.addEventListener('click',function(){
          sticky.classList.remove('arp-sticky--visible');
          try{sessionStorage.setItem('arp_sticky_dismissed','1');}catch(e){}
        });
      }
    }

    /* Copy-link buttons (article share) */
    document.querySelectorAll('[data-arp-copy]').forEach(function(b){
      if(b.__arpBound)return;b.__arpBound=true;
      b.addEventListener('click',function(){
        var url=b.getAttribute('data-arp-copy');
        if(navigator.clipboard){navigator.clipboard.writeText(url).then(function(){b.classList.add('is-copied');setTimeout(function(){b.classList.remove('is-copied');},1400);});}
      });
    });

    /* State-picker typeahead (laws + rebates) */
    document.querySelectorAll('[data-arp-state-picker]').forEach(function(wrap){
      if(wrap.__arpBound)return;wrap.__arpBound=true;
      var input=wrap.querySelector('input');
      var results=wrap.querySelector('[data-results]');
      var tiles=Array.from(wrap.querySelectorAll('[data-state-code]'));
      if(!input||!results||tiles.length===0)return;
      var data=tiles.map(function(t){return {code:t.dataset.stateCode,name:t.dataset.stateName,url:t.getAttribute('href')};});
      var active=-1;
      function render(list){
        results.innerHTML='';
        if(list.length===0){results.hidden=true;return;}
        list.slice(0,8).forEach(function(it){
          var a=document.createElement('a');
          a.href=it.url;a.className='arp-sp__result';
          a.innerHTML='<span class="arp-sp__result-code">'+it.code+'</span><span class="arp-sp__result-name">'+it.name+'</span>';
          results.appendChild(a);
        });
        results.hidden=false;
      }
      function filter(q){
        q=(q||'').trim().toLowerCase();if(!q){render([]);return;}
        var starts=data.filter(function(d){return d.name.toLowerCase().indexOf(q)===0||d.code.toLowerCase()===q;});
        var contains=data.filter(function(d){return d.name.toLowerCase().indexOf(q)>0&&starts.indexOf(d)<0;});
        render(starts.concat(contains));
      }
      input.addEventListener('input',function(){active=-1;filter(input.value);});
      input.addEventListener('keydown',function(e){
        var items=results.querySelectorAll('.arp-sp__result');
        if(e.key==='ArrowDown'){e.preventDefault();active=Math.min(active+1,items.length-1);items.forEach(function(it,i){it.classList.toggle('is-active',i===active);});if(items[active])items[active].scrollIntoView({block:'nearest'});}
        else if(e.key==='ArrowUp'){e.preventDefault();active=Math.max(active-1,0);items.forEach(function(it,i){it.classList.toggle('is-active',i===active);});if(items[active])items[active].scrollIntoView({block:'nearest'});}
        else if(e.key==='Enter'){if(active>=0&&items[active]){e.preventDefault();window.location.href=items[active].href;}}
        else if(e.key==='Escape'){results.hidden=true;active=-1;}
      });
      document.addEventListener('click',function(e){if(!wrap.contains(e.target)){results.hidden=true;}});
    });

    /* Rebate calculator: pick a bike → show effective price */
    document.querySelectorAll('[data-arp-calc]').forEach(function(wrap){
      if(wrap.__arpBound)return;wrap.__arpBound=true;
      var bikes=wrap.querySelectorAll('[data-bike]');
      var rebateInput=wrap.querySelector('[data-calc-rebate]');
      var msrpOut=wrap.querySelector('[data-calc-msrp]');
      var rebOut=wrap.querySelector('[data-calc-rebate-out]');
      var effOut=wrap.querySelector('[data-calc-effective]');
      var nameOut=wrap.querySelector('[data-calc-name]');
      var activeBike=bikes[0];
      function fmt(n){return '$'+Math.round(n).toLocaleString();}
      function render(){
        if(!activeBike)return;
        var msrp=parseFloat(activeBike.dataset.price)||0;
        var reb=parseFloat((rebateInput&&rebateInput.value)||activeBike.dataset.defaultRebate||0)||0;
        var eff=Math.max(0,msrp-reb);
        if(msrpOut)msrpOut.textContent=fmt(msrp);
        if(rebOut)rebOut.textContent='-'+fmt(reb);
        if(effOut)effOut.textContent=fmt(eff);
        if(nameOut)nameOut.textContent=activeBike.dataset.name||'';
      }
      bikes.forEach(function(b){
        b.addEventListener('click',function(){
          bikes.forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false');});
          b.classList.add('is-active');b.setAttribute('aria-pressed','true');
          activeBike=b;render();
        });
      });
      if(rebateInput)rebateInput.addEventListener('input',render);
      if(bikes[0]){bikes[0].classList.add('is-active');bikes[0].setAttribute('aria-pressed','true');}
      render();
    });
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);} else {init();}
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
})();
